import { Redirect, useLocalSearchParams } from 'expo-router'

export default function LegacyFormSummary() {
  const { formToken } = useLocalSearchParams<{ formToken: string }>()
  return <Redirect href={`/forms/${formToken}` as any} />
}
